import cx from "classnames";
import { DataListValue } from "./DataList.model";
import styles from "./DataList.module.scss";
import {
  CategoryName,
  Channel,
  FormattedDate,
  KbCoverage,
  QAScore,
  Release,
  Sentiment,
  Status,
  TicketValidation,
  TTR,
  Agent,
  Collaborators,
} from "../../../routes/explore/cells";
import { SparklesIcon } from "lucide-react";
import { Flex, Text, Tooltip } from "@radix-ui/themes";

function DataListItem({ title, type, value }: DataListValue) {
  return (
    <>
      <div className={styles.Label}>{title}</div>

      <div className={styles.Value}>
        {value == null ? (
          <>-</>
        ) : (
          <>
            {type === "number" && Number(value).toFixed(2)}
            {type === "string" && value}
            {type === "qaScore" && <QAScore value={value} />}
            {type === "status" && <Status value={value} />}
            {type === "kbCoverage" && <KbCoverage value={value} />}
            {type === "channel" && <Channel value={value} />}
            {type === "ttr" && <TTR value={value} />}
            {type === "category" && <CategoryName value={value} />}
            {type === "release" && <Release value={value} />}
            {type === "ticket-validation" && <TicketValidation value={value} />}
            {type === "avgSentiment" && <Sentiment value={value} />}
            {type === "date" && <FormattedDate value={value} />}
            {type === "agent" && <Agent value={value} />}
            {type === "collaborators" && <Collaborators value={value} />}
            {type === "enrichment" && (
              <Flex
                maxWidth={"100%"}
                overflow={"hidden"}
                align="center"
                gap="2"
              >
                <SparklesIcon className={"w-4 h-4 shrink-0"} />

                <Tooltip content={value.reason}>
                  <Text
                    truncate
                    className="px-[6px] py-[2px] bg-[--accent-a3] text-[--accent-a11] rounded-sm"
                  >
                    {value.label}
                  </Text>
                </Tooltip>
              </Flex>
            )}
          </>
        )}
      </div>
    </>
  );
}

interface DataListProps {
  values: DataListValue[];
  className?: string;
}

function DataList({ values, className }: DataListProps) {
  return (
    <div className={cx(styles.DataList, className)}>
      {values.map((item, index) => (
        <DataListItem key={index} {...item} />
      ))}
    </div>
  );
}

export default DataList;
